<div class="comparative-analysis-popover">
  <div class="tab-list">
    <ng-container *ngFor="let item of comparativeAnalysisList">
      <button
        nz-button
        class="compartitve-analysis-list-item"
        [ngClass]="{
          active: activeTab === item.tab_tag,
          disabledButton: !item.show_tab
        }"
        [disabled]="!item.show_tab"
        (mouseover)="item.show_tab && handleComparativeTabChange(item.tab_tag)"
      >
        <span>{{ item.tab_name }}</span>
        <va-icon
          size="small"
          name="chevron-right"
          class="tab-list-icon"
        ></va-icon>
      </button>
    </ng-container>
  </div>
  <div class="tab-details">
    <div
      *ngIf="activeTab === 'industry-peers' && industryData"
      class="industry-peers-container"
    >
      <div class="ianp-container">
        <nz-table
          [nzData]="industryData.columns"
          [nzFrontPagination]="false"
          [nzShowPagination]="false"
          class="ianp-table"
          *ngIf="industryData; else emptyListBlock"
        >
          <thead>
            <tr>
              <th
                *ngFor="let item of industryData.header"
                nzAlign="left"
                class="ianp-header"
              >
                {{ item.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of industryData.columns" class="data-row">
              <td
                [title]="item.industry.label"
                *ngIf="!item.industry.is_link; else linkBlock"
                class="ianp-data-cell"
              >
                {{ item.industry.label }}
              </td>
              <ng-template #linkBlock>
                <td [title]="item.industry.label" class="ianp-data-cell">
                  <a
                    href="/comparative-analysis/current?comp_type=industry&id={{
                      item.industry.id
                    }}&sub_id=-1"
                    target="_blank"
                    class="ianp-link-item"
                    >{{ item.industry.label | textEllipsis: 36 }}
                  </a>
                </td>
              </ng-template>
              <td class="ianp-data-cell">
                <div *ngIf="item.sub_groups && item.sub_groups.length">
                  <div *ngFor="let subGroup of item.sub_groups">
                    <a
                      *ngIf="subGroup.is_link"
                      href="/comparative-analysis/current?comp_type=industry&id={{
                        subGroup.industry_id
                      }}&sub_id={{ subGroup.id }}"
                      target="_blank"
                      class="ianp-link-item"
                      [title]="subGroup.label"
                      >{{ subGroup.label | textEllipsis: 36 }}
                    </a>
                    <div
                      *ngIf="!subGroup.is_link"
                      class="ianp-link-item"
                      [title]="subGroup.label"
                    >
                      {{ subGroup.label | textEllipsis: 36 }}
                    </div>
                  </div>
                </div>
                <div *ngIf="!item.sub_groups || !item.sub_groups.length">-</div>
              </td>
            </tr>
          </tbody>
        </nz-table>

        <ng-template #emptyListBlock>
          <div class="empty-content">No Data Available.</div>
        </ng-template>
      </div>
    </div>
    <div
      *ngIf="
        activeTab === 'comp-tables' && compTabDetails && compTabDetails.length
      "
      class="comp-tables-container"
    >
      <nz-table
        [nzData]="compTabDetails"
        [nzFrontPagination]="false"
        [nzShowPagination]="false"
        [nzScroll]="{ y: '300px' }"
      >
        <thead>
          <tr>
            <ng-container *ngFor="let id of compTabIds">
              <th
                [nzWidth]="
                  id && colKeyStylesMapping[id]
                    ? colKeyStylesMapping[id].width
                    : 'auto'
                "
                [nzAlign]="'left'"
                [ngStyle]="{
                  padding: '0px 8px',
                  'max-width':
                    id && colKeyStylesMapping[id]
                      ? colKeyStylesMapping[id].width
                      : 'auto'
                }"
                class="peer-link-truncate-block"
                nzShowSort
                (nzSortOrderChange)="onSortChange(id, $event)"
              >
                {{ compTabCols[id] }}
              </th>
            </ng-container>
          </tr>
        </thead>
        <tbody
          *ngIf="
            compTabDetails && compTabDetails.length > 0;
            else emptyListBlock
          "
        >
          <tr *ngFor="let data of compTabDetails" class="data-row">
            <ng-container *ngFor="let d of compTabIds">
              <ng-container
                *ngIf="
                  compTabName && compTabName.toLowerCase().includes('analysis');
                  else otherTemplate
                "
              >
                <td
                  [title]="data[d]"
                  *ngIf="d && d !== 'name'; else linkBlock"
                  class="peer-link-truncate-block"
                  [ngStyle]="{
                    'max-width': colKeyStylesMapping[d].width
                  }"
                >
                  {{ data[d] }}
                </td>
                <ng-template #linkBlock>
                  <td [title]="d && data[d]">
                    <a
                      href="/{{ data.link }}"
                      target="_blank"
                      class="peer-link-style"
                      >{{ data[d] | textEllipsis: 80 }}
                    </a>
                  </td>
                </ng-template>
              </ng-container>
              <ng-template #otherTemplate>
                <td
                  [title]="d && data[d]"
                  *ngIf="d && d !== 'name'; else extLinkBlock"
                  class="peer-link-truncate-block"
                  [ngStyle]="{
                    'max-width': colKeyStylesMapping[d].width
                  }"
                >
                  {{ data[d] }}
                </td>
                <ng-template #extLinkBlock>
                  <td [title]="d && data[d]">
                    <a
                      href="/{{ data.link }}"
                      target="_blank"
                      class="peer-link-style"
                    >
                      {{
                        data[d]
                          | textEllipsis
                            : (compTabName.includes("comp") ? 25 : 70)
                      }}</a
                    >
                  </td>
                </ng-template>
              </ng-template>
            </ng-container>
          </tr>
        </tbody>
      </nz-table>
      <ng-template #emptyListBlock>
        <div class="empty-content">No Data Available.</div>
      </ng-template>
    </div>
    <div
      *ngIf="activeTab === 'custom-analysis' && customData"
      class="custom-analysis-container"
    >
      <nz-table
        [nzData]="customData.tab_details"
        [nzFrontPagination]="false"
        [nzShowPagination]="false"
        [nzScroll]="{ y: '300px' }"
      >
        <thead>
          <tr>
            <th
              *ngFor="let id of customData.id"
              [nzWidth]="
                id && colKeyStylesMappingForCustom[id]
                  ? colKeyStylesMappingForCustom[id].width
                  : 'auto'
              "
              [nzAlign]="'left'"
              [ngStyle]="{
                padding: '0px 8px',
                'min-width':
                  id && colKeyStylesMappingForCustom[id]
                    ? colKeyStylesMappingForCustom[id].width
                    : 'auto'
              }"
              class="peer-link-truncate-block"
              [nzShowSort]="customData.cols[id] === 'Page' ? false : true"
              (nzSortOrderChange)="onSortChangeForCustom(id, $event)"
            >
              {{ customData.cols[id] }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of customData.tab_details">
            <td class="page-col">{{ row.topic }}</td>
            <td>
              <a href="/{{ row.link }}" target="_blank">
                {{ row.name }}
              </a>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
    <div
      *ngIf="activeTab === 'watchlists' && watchlistData"
      class="watchlist-container"
    >
      <div *ngFor="let item of watchlistData" class="watchlist-name-item">
        <a
          href="/comparative-analysis/current?comp_type=watchlist&id={{
            item.watcherid
          }}&comps_name={{ item.watchername.replaceAll('&', '%26') }}"
          target="_blank"
          class="watchlist-link"
        >
          {{ item.watchername }}
        </a>
      </div>
    </div>
  </div>
</div>
